module.exports = __webpack_public_path__ + "img/qr_scb.2f71a54e.png";